import React, { useMemo, useCallback } from "react";
import { Card, CardBody, Label, Input, Badge } from "reactstrap";

const OpNumSelector = ({ data, selectedOpNum, onSelect }) => {
  const opNumList = useMemo(() => {
    if (!Array.isArray(data)) return [];

    const opNumberSet = new Set();
    let hasUncategorized = false;

    data.forEach((row) => {
      const op = row?.MOMOperationNum;
      if (op === null || op === undefined || String(op).trim() === "") {
        hasUncategorized = true;
      } else {
        opNumberSet.add(Number(op));
      }
    });

    const sortedOps = Array.from(opNumberSet)
      .filter((x) => Number.isFinite(x))
      .sort((a, b) => a - b);

    const final = [...sortedOps];
    if (hasUncategorized) final.push("Uncategorized");
    if (final.length > 0) final.push("All");

    return final;
  }, [data]);

  const selectedValue = useMemo(() => {
    if (selectedOpNum === null || selectedOpNum === undefined) return "";
    return String(selectedOpNum);
  }, [selectedOpNum]);

  const handleChange = useCallback(
    (e) => {
      const v = e.target.value;
      if (v === "") return onSelect?.(null);
      if (v === "All" || v === "Uncategorized") return onSelect?.(v);
      if (/^\d+$/.test(v)) return onSelect?.(Number(v));
      onSelect?.(null);
    },
    [onSelect]
  );

  return (
    <Card className="shadow-sm" style={{ borderRadius: 12 }}>
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <Label className="mb-0 fw-semibold">Operation</Label>
          <Badge color="light" className="text-muted">
            {opNumList.length} options
          </Badge>
        </div>

        <Input type="select" value={selectedValue} onChange={handleChange}>
          <option value="">Select Op...</option>
          {opNumList.map((op, idx) => (
            <option key={`${op}-${idx}`} value={String(op)}>
              {String(op)}
            </option>
          ))}
        </Input>

        <div className="mt-2 small text-muted">
          Tip: Choose <b>All</b> to see every DNA, or <b>Uncategorized</b> for blank Ops.
        </div>
      </CardBody>
    </Card>
  );
};

export default React.memo(OpNumSelector);